<script setup lang="ts">
import LeLongArrow from "@dsk/icons/LeLongArrow.vue";
import { computed } from "vue";

import { useDictionariesStore } from "@/stores";

const props = defineProps<{
  inline?: boolean;
  methodId: string;
}>();

const tag = computed<string>(() => (props.inline ? "span" : "h4"));

const dictionariesStore = useDictionariesStore();

const sourceLanguage = computed<string>(
  () => dictionariesStore.getMethodByMethodId(props.methodId)?.sourceLanguage ?? ""
);
const targetLanguage = computed<string>(
  () => dictionariesStore.getMethodByMethodId(props.methodId)?.targetLanguage ?? ""
);

const isLanguageLess = computed<boolean>(() => sourceLanguage.value === "" && targetLanguage.value === "");
const isMonolingual = computed<boolean>(
  () => sourceLanguage.value === targetLanguage.value && targetLanguage.value !== ""
);
</script>
<template>
  <Component :is="tag" class="le-method-titles" :class="{ 'le-method-titles--inline': inline }">
    <template v-if="isLanguageLess">
      {{ dictionariesStore.getMethodByMethodId(methodId)?.title }}
    </template>
    <template v-else-if="isMonolingual">
      {{ sourceLanguage }}
    </template>
    <template v-else>
      {{ sourceLanguage }}
      <LeLongArrow class="le-method-titles__long-arrow" :class="{ 'le-method-titles__long-arrow--inline': inline }" />
      {{ targetLanguage }}
    </template>
  </Component>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all";

.le-method-titles {
  display: inline-flex;
  align-items: center;
  margin: 0;

  &:not(&--inline) {
    color: @colors[@neutrals][500];
    font-family: @font-family-heading;
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.75rem;
  }

  &__long-arrow {
    margin: 0 4px;
    color: @colors[@neutrals][400];

    &:not(&--inline) {
      margin: 0 16px;
    }
  }
}
</style>
